

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Routes
} from "react-router-dom";

import Layout from "../layout/Layout";
import WaitlistPage from "../pages/WaitlistPage";


const homeRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<Layout />}>
       
          <Route path="/" element={<WaitlistPage></WaitlistPage>}></Route>

      </Route>

     

    </Route >

  )
);


export default homeRouter;
